export const allowMetricCapture = () => {
    const allowMetric = process.env.NEXT_PUBLIC_CAPTURE_METRIC

    if (!allowMetric) return false;

    return allowMetric.trim().toUpperCase() === "YES";
}

